import React, { useEffect, useState } from "react";
import {BackButton, Title, HeaderWrapper, Duration, ExtendButton} from "./styles";
import {useHistory} from "react-router-dom";
import back from '../../../../assets/images/reservation/back.svg';
import {Trans, useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import { selectError, selectReservationSecondsLeft, selectReservationTimerExtended } from "../../../../store/slices/reservation/selectors";
import moment from "moment";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import {SessionEndedDialog} from "../SessionEndedDialog";
import {ReservationRoutes as Routes} from "../../routes";

const timeout = process.env.REACT_APP_SESSION_TIMEOUT_MINUTES ?
    parseFloat(process.env.REACT_APP_SESSION_TIMEOUT_MINUTES) : 10;

const ReservationHeader = props => {
    const {onBackClicked, forceTimer} = props;
    const {t} = useTranslation();
    const timeLeft = useSelector(selectReservationSecondsLeft);
    const extended = useSelector(selectReservationTimerExtended);
    const dispatch = useDispatch();
    const history = useHistory();
    const error = useSelector(selectError);
    const [reservationError, setReservationError] = useState(false);

    const extendTimer = () => {
        dispatch(reservationActions.extendTimer());
        dispatch(reservationActions.startTimer());
    }

    useEffect(() => {

        if (error === 'EXCEEDED_TIME') {
            dispatch(reservationActions.setForceTimer(false));
            dispatch(reservationActions.setTimerSecondsLeft(0));
            setReservationError(true);
        }
    }, [error])

    return (<HeaderWrapper>
        <BackButton onClick={onBackClicked}>
            <img src={back} alt="back" />
            <span>{t('BACK')}</span>
        </BackButton>
        <Title>
            {(forceTimer || (!window.location.pathname.endsWith(`${Routes.Finished}`) && !window.location.hash.endsWith(`${Routes.Finished}`))) && timeLeft && <>
            <Trans i18nKey="ALMOST_DONE_TITLE" values={{duration: `${
                    moment.duration(timeLeft, "milliseconds").get('minutes').toLocaleString(undefined, {minimumIntegerDigits: 2, useGrouping:false})
                }:${moment.duration(timeLeft, "milliseconds").get('seconds').toLocaleString(undefined, {minimumIntegerDigits: 2, useGrouping:false})}`}}>
                a <Duration red={!timeLeft || timeLeft < 60 * 1000}>b</Duration>c
            </Trans>
            {!extended && (timeLeft && timeLeft < 60 * 1000) && <ExtendButton onClick={extendTimer}>{t('EXTEND_FOR_10_MORE')}</ExtendButton>}
            </>}
        </Title>
        <div/>

        <SessionEndedDialog
            open={(( !window.location.pathname.endsWith(`${Routes.Finished}`) && !window.location.hash.endsWith(`${Routes.Finished}`)) && (timeLeft === 0 && !forceTimer))
                    || (reservationError && !!( window.location.pathname.endsWith(`/${Routes.Finished}`) || window.location.hash.endsWith(`${Routes.Finished}`))) }
            onClose={() => {
                dispatch(reservationActions.clear());
                history.replace('/');
            }}
            onRecheck={() => {
                //clear all states
                dispatch(reservationActions.reloadReservationProposals());
                history.go(reservationError ? -2 : -1);
            }} />
    </HeaderWrapper>)
}

ReservationHeader.propTypes = {
    forceTimer: PropTypes.bool,
    onBackClicked: PropTypes.func,
}

export default ReservationHeader;
